type AddressBook = {
  factory: string;
  roles: {
    owner: string;
    controller: string;
    feeCollector: string;
  };
};

const getAddressBook = async (): Promise<AddressBook> => {
  const response = await fetch(`${import.meta.env.VITE_API_URL}/address-book`, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });
  if (!response.ok) {
    throw new Error("Error fetching wallet activity stats");
  }

  const data = (await response.json()) as AddressBook;

  return data;
};

export { getAddressBook };
export type { AddressBook };
